import { useContext } from "react";
import { langContext } from "../api/Lang";

const el = {
    noTheme: "Δεν βρέθηκε θέμα για αυτή την ομάδα σχολείων.",
    errorLoadingSchools: "Σφάλμα φόρτωσης σχολείων.",
    noSchoolsForGroup: "Δεν βρέθηκαν σχολεία για αυτή την ομάδα.",
    selectSchoolHeading: "Επίλεξε σχολείο",
    selectSchoolDescription:
        "Επίλεξε το σχολείο σου για να συνδεθείς στο σύστημα παραγγελιών φαγητού",
    selectCampHeading: "Επίλεξε Camp",
    selectCampDescription:
        "Επίλεξε το θερινό camp σου για να συνδεθείς στο σύστημα παραγγελιών φαγητού",
    foodConceptBy: "Food concept by",
    languageToggleLabel: "Ελληνικά",
    languageToggleFlagSrc: "../img-assets/el.jpg",
    gefsinusAlt: "Gefsinus",
    lunchboxAlt: "Lunchbox",
    languageAlt: "Γλώσσα",
};

const en: typeof el = {
    noTheme: "No theme found for this school group.",
    errorLoadingSchools: "Error loading schools.",
    noSchoolsForGroup: "No schools found for this group.",
    selectSchoolHeading: "Select School",
    selectSchoolDescription: "Select your school to connect to the food ordering system",
    selectCampHeading: "Select Camp",
    selectCampDescription: "Select your summer camp to connect to the food ordering system",
    foodConceptBy: "Food concept by",
    languageToggleLabel: "English",
    languageToggleFlagSrc: "../img-assets/en.png",
    gefsinusAlt: "Gefsinus",
    lunchboxAlt: "Lunchbox",
    languageAlt: "Language",
};

const schoolLandingLangs = { el, en };

export function useSchoolLandingStrings() {
    const [lang] = useContext(langContext);
    return schoolLandingLangs[lang];
}
